import { useSnackbar } from 'contexts/snackbar';
import { useViewport } from 'contexts/viewport';
import moment from 'moment';
import { PageContext } from 'pages/ForgotPassword/PageProvider';
import Desktop from 'pages/ForgotPassword/desktop';
import Mobile from 'pages/ForgotPassword/mobile';
import Tablet from 'pages/ForgotPassword/tablet';
import queryString from 'query-string';
import { useContext, useEffect } from 'react';
import { Loading } from 'shell/components';

const PageLayout = ({ location }) => {
    const { message } = useSnackbar();
    const { device } = useViewport();

    const { loading, handleChange, handleNext, setLoading, PAGES } = useContext(PageContext);

    useEffect(() => {
        const { userName, code, createdOn } = queryString.parse(location.search);
        if (code) {
            setLoading(true);
            const isExpired = moment(createdOn).diff(new Date().getTime(), 'minutes') > 60;
            if (isExpired) {
                message.error('The code is expired. Please reset your password again.');
                setLoading(false);
            } else if (userName && code) {
                handleChange('code', code);
                handleChange('email', userName);
                handleNext(PAGES.NEW_PASSWORD);
            }
            setLoading(false);
        }
    }, [location?.search]);

    const props = {};

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return loading ? <Loading /> : renderResponsiveLayout(device);
};

export default PageLayout;
